// extracted by mini-css-extract-plugin
export default {"container":"Rqxz9ZAY__GEP1mxgJtK","label":"QEYld_3eJv32i3q8t97K","text":"_LZpjvvDVOMz7v3SefMP","termsContainer":"FuoSDfr3w6yPLwUW82cp","pulse":"e74K_CkO8dutieuvFbuq"};